import * as classnames from 'classnames'
import * as React from 'react'

import ImagePreview from '../../../components/imagePreview'
import TrendingSash from '../../../components/trendingSash'
import SaleSash from '../../../components/saleSash'
import ImagePlaceholder from '../../imagePlaceholder'
import { IItemCard } from '../interface'
import LockupPreviewActionPanel from '../lockupPreviewActionPanel'
import FeatureContainer from '../../../containers/feature'

import * as styles from './itemCardSquarePreview.module.css'

const ItemCardSquarePreview = (props: IItemCard) => {
  const { item, onItemLinkClick, viewType, isCardHovered } = props

  const rootClass = classnames({
    [styles.listView]: viewType === 'list',
    [styles.isCardHovered]: isCardHovered
  })

  let sash = null
  if (item.trending) sash = <TrendingSash lazy large />
  // For author driven price experiment
  if (item.original_price_cents)
    sash = (
      <FeatureContainer name="showWasNowPricing">
        <SaleSash lazy large />
      </FeatureContainer>
    )

  return (
    <section className={rootClass}>
      {sash}
      <a href={item.url} onClick={onItemLinkClick}>
        <ImagePlaceholder ratio={1}>
          <ImagePreview previews={item.previews} alt={item.name} />
        </ImagePlaceholder>
      </a>
      <section
        className={styles.hoverOverlay}
        data-test-selector="preview-action-panel"
      >
        <a
          href={item.url}
          onClick={onItemLinkClick}
          className={styles.hoverOverlayClickHandler}
          role="toolbar"
          title={item.name}
        />
        <section className={styles.hoverOverlayActions}>
          <LockupPreviewActionPanel {...props} />
        </section>
      </section>
    </section>
  )
}

export default ItemCardSquarePreview
